export default "__VITE_ASSET__Csk98mtL__"